import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledPeriod = styled.div`
  display: flex;
  align-items: center;
  transition: all linear 1s;
  &.isOnTransition {
    transform: scale(0.8, 0.8);
  }
  & .refreshButton {
    margin-left: 1rem;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    background: ${getColor('chambray')};
    &:hover {
      background: ${getColor('darkBlue')};
      cursor: pointer;
    }

    & svg#Refresh {
      -webkit-transform: scaleX(-1);
      transform: scaleX(-1);
    }
  }
`;
